import React, { Component } from 'react';
import moment from 'moment';

class SetsContentModal extends Component {
  render() {
    const { onSave, setsContentData, onCanel } = this.props;
    return (
      <div
        className="modal fade theme-modal" id="SetsContentModalModal"
        tabIndex="-1" aria-labelledby="SetsContentModalModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-body">
              <div style={{ color: '#000', fontSize: 16 }}>The selected set is planned for an upcoming case. If possible, </div>
              <div style={{ color: '#000', fontSize: 16 }}>consider moving a different set.</div>

              <div style={{
                width: '100%', marginBottom: 2, padding: 10, color: '#000', fontSize: 16
              }}
              >
                <table>
                  <tbody>
                    <tr>
                      <td width={100}>Next Case: </td>
                      <td>{setsContentData.NextCase}</td>
                    </tr>
                    <tr>
                      <td>Next Date: </td>
                      <td>{setsContentData.NextDate && moment(setsContentData.NextDate).format('L')}</td>
                    </tr>
                    <tr>
                      <td>Next Loc: </td>
                      <td>{setsContentData.NextLocName}</td>
                    </tr>
                    <tr>
                      <td>Next Rep: </td>
                      <td>{setsContentData.NextRep}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal" onClick={() => onCanel()}>Cancel</button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onSave()}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SetsContentModal;
